<template>
<div>
    <el-input v-if="isEditing" v-model="comments" maxlength="200" class="search-InputBox" size="mini" :placeholder="comments"></el-input>
    <el-button v-if="isEditing" icon="el-icon-success" class="margin-left-10" size="small" type="text" @click="saveComment()"></el-button>
    <el-button v-if="isEditing" icon="el-icon-error" class="gray" size="small" type="text" @click="Reset()"></el-button>
    <span v-if="!isEditing">
        {{comments}}
    </span>
</div>
</template>

<style lang="scss" scoped>
.cs-accountList-payment {
    span {
        display: inline-block;
        margin-right: 1px;
    } 
}

.gray {
    color: gray;
    margin-left: 3px;
}

.margin-left-10 {
    margin-left: 10px;
}

.search-InputBox {
    width: 140px;
}
</style>

<script>
import {
    saveCommentsChange
} from "../../../service/finance.service.js"
export default {
    props: {
        data: {},
        columnData: {},
        status: {},
        editLocation: {},
    },
    data() {
        return {
            comments: undefined,
            isEditing: false,
            originaComments: ""
        };
    },
    components: {},
    created() { 
        this.init();
    },
    methods: {
        init(){
             this.comments = this.data.Comment;
            this.originaComments = this.comments;
        },
        saveComment() {
            let self = this;
            saveCommentsChange(this.data.Id, this.comments)
                .then(result => {
                    if (!!result && result.success) {
                        this.$message({
                            type: 'success',
                            message: '备注更新成功!'
                        });
                        self.originaComments = self.comments;
                        self.Reset();
                    } else {
                        self.Reset();
                        this.$message({
                            type: 'error',
                            message: '备注更新失败! ' + result.message
                        });
                    }
                })
        },
        Reset() {
            this.isEditing = false;
            this.comments = this.originaComments;
        }
    },
    watch: {
        editLocation: function () {
            if (this.data.IsRefund){
                return;
            }

            if (this.editLocation && this.editLocation.columnLabel == "备注" && this.editLocation.rowIndex == this.data.Index) {
                this.isEditing = true;
            } else {
                this.isEditing = false;
            }
        },
        data:function(){
            this.init();
        },
        status: function () {}
    }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/saleQueryCommentCell.vue